export default __webpack_public_path__ + "static/media/trash-icon.0bdff8ce.svg";